// A simple metronome written using Javascript and the Web Audio API.
// Source: https://github.com/grantjames/metronome
// Interpreted and modified by: Çağrı Erdem, 2023 

export class Metronome
{
    constructor(tempo = 120, volume = 0.5)
    {
        this.audioContext = null;
        this.notesInQueue = [];         // notes that have been put into the web audio and may or may not have been played yet {note, time}
        this.currentBeatInBar = 0;
        this.beatsPerBar = 4;
        this.tempo = tempo;
        this.lookahead = 25;          // How frequently to call scheduling function (in milliseconds)
        this.scheduleAheadTime = 0.1;   // How far ahead to schedule audio (sec)
        this.nextNoteTime = 0.0;     // when the next note is due
        this.isRunning = false;
        this.intervalID = null;
        this.mute = false; // Add a mute property
        this.volume = 0.4; // Add a setVolume property
    }

    nextNote()
    {
        // Advance current note and time by a quarter note (crotchet if you're posh)
        var secondsPerBeat = 60.0 / this.tempo; // Notice this picks up the CURRENT tempo value to calculate beat length.
        this.nextNoteTime += secondsPerBeat; // Add beat length to last beat time
    
        this.currentBeatInBar++;    // Advance the beat number, wrap to zero
        if (this.currentBeatInBar == this.beatsPerBar) {
            this.currentBeatInBar = 0;
        }
    }

    //TODO: push it to the actual repo
    setVolume(newVolume) {
        this.volume = newVolume;
    }

    scheduleNote(beatNumber, time)
    {
        if (this.mute) return; // Don't play the sound if muted

        // push the note on the queue, even if we're not playing.
        this.notesInQueue.push({ note: beatNumber, time: time });
    
        // create an oscillator
        const osc = this.audioContext.createOscillator();
        const envelope = this.audioContext.createGain();
        
        osc.frequency.value = (beatNumber % this.beatsPerBar == 0) ? 1000 : 1000; //800 yerine 1000 yaptim ikincisini de 1/4 seklinde gelsin click'ler diye
        envelope.gain.value = this.volume;
        envelope.gain.exponentialRampToValueAtTime(this.volume, time + 0.001);
        envelope.gain.exponentialRampToValueAtTime(0.001, time + 0.05);

        osc.connect(envelope);
        envelope.connect(this.audioContext.destination);
    
        osc.start(time);
        osc.stop(time + 0.03);
    }

    scheduler()
    {
        // while there are notes that will need to play before the next interval, schedule them and advance the pointer.
        while (this.nextNoteTime < this.audioContext.currentTime + this.scheduleAheadTime ) {
            this.scheduleNote(this.currentBeatInBar, this.nextNoteTime);
            this.nextNote();
        }
    }

    start()
    {
        if (this.isRunning) return;

        if (this.audioContext == null)
        {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }

        this.isRunning = true;

        this.currentBeatInBar = 0;
        this.nextNoteTime = this.audioContext.currentTime + 0.02; //0.05

        this.intervalID = setInterval(() => this.scheduler(), this.lookahead);
    }

    stop()
    {
        this.isRunning = false;

        clearInterval(this.intervalID);
    }

    startStop()
    {
        if (this.isRunning) {
            this.stop();
        }
        else {
            this.start();
        }
    }

    // Method to toggle the mute state
    //TODO: push it to the actual repo
    toggleMute() 
    {
        this.mute = !this.mute;
    }

    // Modify the method responsible for playing the metronome tick
    playTick() 
    {
        if (this.mute) {
            // If muted, skip playing the sound
            return;
        }
        // Otherwise, play the tick sound
    }

    // Resetting the Metronome's currentBeatInBar for Loop Synchronization
    //TODO: push it to the actual repo -- ALSO perhaps `reset()` would be a better name
    reset() 
    {
        this.currentBeatInBar = 0;
        // Any additional logic needed to reset the metronome for a new loop
    }

    alignWithGrooveStart(startTime) 
    {
        this.nextNoteTime = startTime; // Align the metronome's next note time with the groove start time
        this.currentBeatInBar = 0; // Optionally reset the beat counter if needed
    }
    
}